import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Form, Row, Col, FormGroup, FormText, Label, Input, ButtonGroup, Button, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { addReviewRequest, REVIEW_SCORE_MAX } from '../../ReviewActions';
import { getLoggedUser } from '../../../User/UserActions';

import FontCustom from '../../../../components/Content/FontCustom';

class ReviewAddForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            review: {
                name: '',
                text: '',
                link: '',
                score: 5,
            },
            isLoading: false,
            isSuccess: false,
        };
    }

    componentDidMount() {
        this.initUser();
    }

    componentDidUpdate(prevProps, prevState) {
        if(!prevProps.user || prevProps.user !== this.props.user) {
            this.initUser();
        }
    }

    initUser = () => {
        if(this.props.user) {
            this.setState({
                review: {
                    ...this.state.review,
                    name: `${this.props.user.firstName || ''} ${this.props.user.lastName || ''}`,
                },
            });
        }
    }

    handleChange = event => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState({
            review: {
                ...this.state.review,
                [name]: value,
            },
        });
    }

    handleSetScore = (event, score) => {
        event.preventDefault();
        this.setState({
            review: {
                ...this.state.review,
                score,
            },
        });
    }

    handleSubmit = event => {
        event.preventDefault();
        if(this.isValid()) {
            this.setState({
                isLoading: true,
            });
            this.props.dispatch(addReviewRequest({
                ...this.state.review,
                language: this.props.intl.locale,
            })).then(review => {
                if(review) {
                    this.setState({
                        isLoading: false,
                        isSuccess: true,
                    });
                }
            });
        }
    }

    isValid = () => {
        const { review } = this.state;
        return review.score !== null && review.name && (review.text || review.link);
    }

    render() {
        const { review, isSuccess, isLoading } = this.state;
        if(isSuccess || isLoading) {
            return (
                <Alert color="success" className="text-center">
                    {
                        isLoading
                        ? <span className="h5"><FontAwesome name="spinner" spin /> <FormattedMessage id="reviewAddLoading" defaultMessage="We send your review..." /></span>
                        : <span className="h5"><FontAwesome name="check-circle" /> <FormattedMessage id="reviewAddSuccess" defaultMessage="We well received your review! It will be displayed after moderation..." /></span>
                    }
                </Alert>
            );
        }
        if(this.props.user) {
            return (
                <Form onSubmit={this.handleSubmit} className="py-3">
                    <FormGroup className="mr-2 mb-2">
                        <Input type="text" name="name" value={review.name} placeholder={this.props.intl.formatMessage({ id: 'reviewName', defaultMessage: 'Name and country' })} onChange={this.handleChange} />
                    </FormGroup>
                    <FormGroup className="mr-2 mb-2">
                        <Input type="text" name="title" value={review.title} placeholder={this.props.intl.formatMessage({ id: 'reviewTitle', defaultMessage: 'Title' })} onChange={this.handleChange} />
                    </FormGroup>
                    <Row>
                        <Col xs="12" md="6" lg="3">
                            <Label><FormattedMessage id="reviewScoreLabel" defaultMessage="Choose your note" /></Label>
                        </Col>
                        <Col>
                            <div className="review-score m-auto text-center" style={{ width: '8em' }}>
                                {Array(REVIEW_SCORE_MAX).fill(1).map((i, index) => index + 1).map(score => <a href="#" onClick={event => this.handleSetScore(event, score)} className={classnames('d-inline-block', 'w-20', review.score >= score && 'text-warning')}><FontCustom name="star" size="2" /></a>)}
                            </div>
                        </Col>
                    </Row>
                    <FormGroup className="mr-2 mb-2">
                        <Input type="textarea" name="text" value={review.text} rows={6} placeholder={this.props.intl.formatMessage({ id: 'reviewText', defaultMessage: 'Type your review...' })} onChange={this.handleChange} />
                    </FormGroup>
                    <FormGroup className="mr-2 mb-2">
                        <Input type="text" name="link" value={review.link} placeholder={this.props.intl.formatMessage({ id: 'reviewLink', defaultMessage: 'Paste the link of your video' })} onChange={this.handleChange} />
                        <FormText><FormattedMessage id="reviewLinkHelp" defaultMessage="Record your video with YouTube (for example) and copy the video link in this field above" /></FormText>
                    </FormGroup>

                    <div className="text-right">
                        <ButtonGroup size="sm">
                            <Button color="warning" disabled={!this.isValid() || this.state.isLoading} onClick={this.handleSubmit}>
                                <span><FontAwesome name="marker" /> <FormattedMessage id="reviewAddFirstReviewButton" defaultMessage="Add my review" /></span>
                            </Button>
                        </ButtonGroup>
                    </div>
                </Form>
            );
        }
        return null;
    }
}

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
    };
}

ReviewAddForm.defaultProps = {
    user: null,
};

ReviewAddForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    user: PropTypes.object,
};

export default connect(mapStateToProps)(injectIntl(ReviewAddForm));
